// Bridge utilities for communicating with React Native WebView

export const isInWebView = (): boolean => {
  return typeof window !== "undefined" && !!(window as any).ReactNativeWebView;
};

export const postMessageToNative = (message: any): void => {
  if (isInWebView()) {
    const messageString =
      typeof message === "string" ? message : JSON.stringify(message);
    (window as any).ReactNativeWebView.postMessage(messageString);
  }
};

export const notifyLogout = (): void => {
  postMessageToNative({
    type: "LOGOUT",
    timestamp: Date.now(),
  });
};

export const notifyLoginSuccess = (userData?: any): void => {
  postMessageToNative({
    type: "AUTH_SUCCESS",
    timestamp: Date.now(),
    user: userData,
  });
};

export const authStatusSync = (authData?: any): void => {
  postMessageToNative({
    type: "AUTH_STATUS_SYNC",
    timestamp: Date.now(),
    authData: authData,
  });
};

export const notifyRevenueCatLogin = (userData?: any): void => {
  postMessageToNative({
    type: "REVENUECAT_LOGIN",
    timestamp: Date.now(),
    user: userData,
  });
};

export const notifyRequestPayment = (
  productIds: {
    ios: string;
    android: string;
  },
  productType: "subscription" | "non_subscription"
): void => {
  postMessageToNative({
    type: "REQUEST_PAYMENT",
    timestamp: Date.now(),
    productIds: productIds,
    productType: productType,
  });
};

// Ask the native app to preload a set of products for faster purchases
export const preloadPurchaseProducts = (
  products: Array<{
    productIds: { ios: string; android: string };
    productType: "subscription" | "non_subscription";
  }>
): void => {
  postMessageToNative({
    type: "PRELOAD_PURCHASE_PRODUCTS",
    timestamp: Date.now(),
    products,
  });
};

// Notify native app that a given route is fully mounted/ready
export const notifyPurchaseConfirmed = (route: string): void => {
  postMessageToNative({
    type: "PURCHASE_CONFIRMED",
    timestamp: Date.now(),
    route,
  });
};

// Open native subscription management (handled in React Native)
export const notifyManageSubscription = (): void => {
  postMessageToNative({
    type: "MANAGE_SUBSCRIPTION",
    timestamp: Date.now(),
  });
};

